import {storeSet} from "@/mixins/Auth";

export default [
    { // 메인
        path: '/',
        component: () => import("../views/Home.vue"),
        name: "Home",
        beforeEnter: storeSet,
        meta: {
            name: "Home", title: "홈", side: 'dash',
            sideMenu: true,
            sideName: '대시보드',
            authRequired: true, storeRequired: true, storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER','ROLE_NORMAL']
        },

    },
    { // 로그인
        path: '/auth',
        component: () => import("../views/auth/Login.vue"),
        name: "Login",
        meta: {
            name: "Login", title: "로그인",
        },
    },


    // ===== 슈퍼 관리자용 일반 관리자 관리 =====
    {
        path: '/admin',
        component: () => import("../views/admin/Admin.vue"),
        name: "Admin",
        beforeEnter: storeSet,
        meta: {
            name: "Admin",
            title: '일반 관리자 관리',
            sideName: '일반 관리자 관리',
            side: 'admin',
            sideMenu: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER']
        }
    },
    {
        path: '/admin/create',
        component: () => import('../views/admin/AdminCreate.vue'),
        name: 'AdminCreate',
        beforeEnter: storeSet,
        meta: {
            name: 'AdminCreate',
            title: '일반 관리자 등록',
            side: 'admin',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER']
        }
    },
    {
        path: '/admin/:idx/update',
        component: () => import('../views/admin/AdminUpdate.vue'),
        name: 'AdminUpdate',
        beforeEnter: storeSet,
        meta: {
            name: 'AdminUpdate',
            title: '일반 관리자 수정',
            side: 'admin',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER']
        }
    },
    {
        path: '/admin/update',
        component: () => import('../views/admin/AdminUpdateSelf.vue'),
        name: 'AdminUpdateSelf',
        beforeEnter: storeSet,
        meta: {
            name: 'AdminUpdateSelf',
            title: '일반 관리자 수정',
            side: 'admin',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_NORMAL' ]
        }
    },
    {
        path: '/admin/:idx',
        component: () => import('../views/admin/AdminDetail.vue'),
        name: 'AdminDetail',
        beforeEnter: storeSet,
        meta: {
            name: 'AdminDetail',
            title: '일반 관리자 상세',
            side: 'admin',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER']
        },
        children: [
            {
                path: 'client', 
                component: () => import('../views/admin/AdminDetailClient.vue'),
                name: 'AdminDetailClient',
                beforeEnter: storeSet,
                meta: {
                    name: 'AdminDetailClient',
                    title: '일반 관리자 상세',
                    side: 'admin',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_SUPER']
                },
            },
        ],
    },
    // ===== 슈퍼 관리자용 일반 관리자 관리 =====
    
    // ===== 일반 관리자용 고객사 관리 =====
    {
        path: '/charge',
        component: () => import("../views/charge/Charge.vue"),
        name: "Charge",
        beforeEnter: storeSet,
        meta: {
            name: "Charge",
            title: '담당 고객사 관리',
            sideName: '담당 고객사 관리',
            side: 'charge',
            sideMenu: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_NORMAL'],
        }
    },
    {
        path: '/charge/:cuIdx',
        component: () => import("../views/charge/ChargeDetail.vue"),
        name: "ChargeDetail",
        beforeEnter: storeSet,
        meta: {
            name: "ChargeDetail",
            title: '담당 고객사 상세',
            side: 'charge',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_NORMAL'],
        },
        children: [
            {
                path: 'mail',
                component: () => import("../views/charge/ChargeDetailMailing.vue"),
                name: "ChargeDetailMailing",
                beforeEnter: storeSet,
                meta: {
                    name: "ChargeDetailMailing",
                    title: '담당 고객사 상세',
                    side: 'charge',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_NORMAL'],
                },
            },
            {
                path: 'keyword',
                component: () => import("../views/charge/ChargeDetailKeyword.vue"),
                name: "ChargeDetailKeyword",
                beforeEnter: storeSet,
                meta: {
                    name: "ChargeDetailKeyword",
                    title: '담당 고객사 상세',
                    side: 'charge',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_NORMAL'],
                },
            },
            {
                path: 'stopword',
                component: () => import("../views/charge/ChargeDetailStopword.vue"),
                name: "ChargeDetailStopword",
                beforeEnter: storeSet,
                meta: {
                    name: "ChargeDetailStopword",
                    title: '담당 고객사 상세',
                    side: 'client',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_NORMAL'],
                },
            },
            {
                path: 'wordcloud',
                component: () => import("../views/charge/ChargeDetailWordCloud.vue"),
                name: "ChargeDetailWordCloud",
                beforeEnter: storeSet,
                meta: {
                    name: "ChargeDetailWordCloud",
                    title: '담당 고객사 상세',
                    side: 'client',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_NORMAL'],
                },
            },
            {
                path: 'crawling',
                component: () => import("../views/charge/ChargeDetailCrawlingHistory.vue"),
                name: "ChargeDetailCrawlingHistory",
                beforeEnter: storeSet,
                meta: {
                    name: "ChargeDetailCrawlingHistory",
                    title: '담당 고객사 상세',
                    side: 'charge',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_NORMAL'],
                },
            },
            {
                path: 'llm',
                component: () => import("../views/charge/ChargeDetailLlmHistory.vue"),
                name: "ChargeDetailLlmHistory",
                beforeEnter: storeSet,
                meta: {
                    name: "ChargeDetailLlmHistory",
                    title: '담당 고객사 상세',
                    side: 'charge',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_NORMAL'],
                },
            },
            {
                path: 'report',
                component: () => import("../views/report/ReportMember.vue"),
                name: "ReportMember",
                beforeEnter: storeSet,
                meta: {
                    name: "ReportMember",
                    title: "레포트 관리",
                    sideName: '레포트 관리',
                    side: 'charge',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_NORMAL'],
                },
            },
            {
                path: 'news',
                component: () => import("../views/news/NewsMember.vue"),
                name: "NewsMember",
                beforeEnter: storeSet,
                meta: {
                    name: "NewsMember",
                    title: "뉴스클리핑",
                    sideName: '뉴스클리핑',
                    side: 'charge',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_NORMAL'],
                },
                
            },
            {
                path: 'info',
                component: () => import("../views/charge/ChargeInfo.vue"),
                name: "ChargeInfo",
                beforeEnter: storeSet,
                meta: {
                    name: "ChargeInfo",
                    title: "고객사 정보",
                    sideName: '고객사 정보',
                    side: 'charge',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_NORMAL'],
                },
            },
           
        ],
    },
    // ==== 일반 관리자용 고객사 관리 =====

    // ===== 슈퍼 관리자용 고객사 관리 =====
    {
        path: '/client',
        component: () => import("../views/client/Client.vue"),
        name: "Client",
        beforeEnter: storeSet,
        meta: {
            name: "Client",
            title: '고객사 관리',
            sideName: '고객사 관리',
            side: 'client',
            sideMenu: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER'],
        }
    },
    {
        path: '/client/create',
        component: () => import('../views/client/ClientCreate.vue'),
        name: 'ClientCreate',
        beforeEnter: storeSet,
        meta: {
            name: 'ClientCreate',
            title: '고객사 등록',
            side: 'client',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER'],
        }
    },

    {
        path: '/client/:idx/update',
        component: () => import('../views/client/ClientUpdate.vue'),
        name: 'ClientUpdate',
        meta: {name: 'ClientUpdate', title: '고객사 수정', side: 'client', role: ['ROLE_SUPER']}
    },
    {
        path: '/client/:cuIdx',
        component: () => import('../views/client/ClientDetail.vue'),
        name: 'ClientDetail',
        beforeEnter: storeSet,
        meta: {
            name: 'ClientDetail',
            title: '고객사 상세',
            side: 'client',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER'],
        },
        children: [
            {
                path: 'mail',
                component: () => import("../views/charge/ChargeDetailMailing.vue"),
                name: "ChargeDetailMailingSuper",
                beforeEnter: storeSet,
                meta: {
                    name: "ChargeDetailMailing",
                    title: '담당 고객사 상세',
                    side: 'client',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_SUPER'],
                },
            },
            {
                path: 'keyword',
                component: () => import("../views/charge/ChargeDetailKeyword.vue"),
                name: "ChargeDetailKeywordSuper",
                beforeEnter: storeSet,
                meta: {
                    name: "ChargeDetailKeyword",
                    title: '담당 고객사 상세',
                    side: 'client',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_SUPER'],
                },
            },
            {
                path: 'stopword',
                component: () => import("../views/charge/ChargeDetailStopword.vue"),
                name: "ChargeDetailStopwordSuper",
                beforeEnter: storeSet,
                meta: {
                    name: "ChargeDetailStopword",
                    title: '담당 고객사 상세',
                    side: 'client',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_SUPER'],
                },
            },
            {
                path: 'wordcloud',
                component: () => import("../views/charge/ChargeDetailWordCloud.vue"),
                name: "ChargeDetailWordCloudSuper",
                beforeEnter: storeSet,
                meta: {
                    name: "ChargeDetailWordCloud",
                    title: '담당 고객사 상세',
                    side: 'client',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_SUPER'],
                },
            },
            {
                path: 'crawling', //고객사 상세 -> 크롤링 히스토리
                component: () => import('../views/client/ClientDetailCrawlingHistory.vue'),
                name: 'ClientClientDetailCrawlingHistory',
                beforeEnter: storeSet,
                meta: {
                    name: 'ClientDetailCrawlingHistory',
                    title: '고객사 상세',
                    side: 'client',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_SUPER'],
                },
            },
            {
                path: 'llm', //고객사 상세 -> LLM 히스토리
                component: () => import('../views/client/ClientDetailLlmHistory.vue'),
                name: 'ClientDetailLlmHistory',
                beforeEnter: storeSet,
                meta: {
                    name: 'ClientDetailLlmHistory',
                    title: '고객사 상세',
                    side: 'client',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_SUPER'],
                },
            },
            
            {
                path: 'report',
                component: () => import("../views/report/ReportMember.vue"),
                name: "ReportMemberSuper",
                beforeEnter: storeSet,
                meta: {
                    name: "ReportMember",
                    title: "레포트 관리",
                    sideName: '레포트 관리',
                    side: 'client',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_SUPER'],
                },
            },
            {
                path: 'news',
                component: () => import("../views/news/NewsMember.vue"),
                name: "NewsMemberSuper",
                beforeEnter: storeSet,
                meta: {
                    name: "NewsMember",
                    title: "뉴스클리핑",
                    sideName: '뉴스클리핑',
                    side: 'client',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_SUPER'],
                },
            },
            {
                path: 'dashboard',
                component: () => import("../views/dashboard/Dashboard.vue"),
                name: "DashboardSuper",
                beforeEnter: storeSet,
                meta: {
                    name: "Dashboard",
                    title: "대시보드",
                    sideName: '대시보드',
                    side: 'client',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    role: ['ROLE_SUPER'],
                },
            },

        ],
    },
    // ===== 슈퍼 관리자용 고객사 관리 =====


    // =====크롤링 관리 =====
   
    {
        path: '/crawling/history',
        component: () => import("../views/crawling/CrawlingHistory.vue"),
        name: "CrawlingHistory",
        beforeEnter: storeSet,
        meta: {
            name: "CrawlingHistory",
            title: "Crawling",
            side: 'crawling',
            sideMenu: true,
            sideName: 'Crawling',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_NORMAL','ROLE_SUPER'],
        },
    },
    {
        path: '/crawling/history/:cuIdx/:crIdx',
        component: () => import("../views/crawling/CrawlingHistorySummary.vue"),
        name: "Crawling Summary",
        beforeEnter: storeSet,
        meta: {
            name: "Crawling Summary",
            title: "Crawling Summary",
            side: 'crawling',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ["ROLE_SUPER",'ROLE_NORMAL'],
        },
    },
    {
        path: '/crawling/history/:cuIdx/:crIdx/:cdsIdx',
        component: () => import("../views/crawling/CrawlingDetail.vue"),
        name: "CrawlingHistoryDetailDetail",
        beforeEnter: storeSet,
        meta: {
            name: "CrawlingHistoryDetail",
            title: "Crawling History Detail",
            side: 'crawling',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER','ROLE_NORMAL'],
        },
    },
    // =====크롤링 관리 =====

    // ===== LLM 관리 =====
    {
        path: '/llm/history',
        component: () => import("../views/llm/LlmHistory.vue"),
        name: "LlmHistory",
        beforeEnter: storeSet,
        meta: {
            name: "LlmHistory",
            title: "LLM",
            side: 'llm',
            sideName: 'LLM',
            sideMenu: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_NORMAL','ROLE_SUPER'],
        },
    },
    {
        path: '/llm/history/:cuIdx/:llIdx',
        component: () => import("../views/llm/LlmHistorySummary.vue"),
        name: "LlmHistorySummary",
        beforeEnter: storeSet,
        meta: {
            name: "LlmHistorySummary",
            title: "LLM Summary",
            side: 'llm',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER','ROLE_NORMAL'],
        },
    },
    {
        path: '/llm/history/:cuIdx/:llIdx/:ldIdx',
        component: () => import("../views/llm/LlmHistoryDetail.vue"),
        name: "LlmHistoryDetail",
        beforeEnter: storeSet,
        meta: {
            name: "LlmHistoryDetail",
            title: "LLM Detail",
            side: 'llm',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER','ROLE_NORMAL'],
        },
    },
    // ===== LLM 관리 =====



    // == 보도자료 관리 ==
    {
        path: '/release',
        component: () => import("../views/release/PressRelease.vue"),
        name: "PressRelease",
        beforeEnter: storeSet,
        meta: {
            name: "Release",
            title: "보도자료 관리",
            side: 'release',
            sideName: '보도자료 관리',
            sideMenu: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER','ROLE_NORMAL'],
        },
    },
     {
        path: '/release/create',
        component: () => import("../views/release/PressReleaseCreate.vue"),
        name: "PressReleaseCreate",
        beforeEnter: storeSet,
        meta: {
            name: "PressReleaseCreate",
            title: "보도자료 등록",
            side: 'release',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER','ROLE_NORMAL'],
        },
    },
     {
        path: '/release/:key',
        component: () => import("../views/release/PressReleaseDetail.vue"),
        name: "PressReleaseDetail",
        beforeEnter: storeSet,
        meta: {
            name: "PressReleaseDetail",
            title: "보도자료 상세",
            side: 'release',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER','ROLE_NORMAL'],
        },
    },
    // == 보도자료 관리 ==

    // ===== 레포트 관리 =====
    {
        path: '/report',
        component: () => import("../views/report/Report.vue"),
        name: "Report",
        beforeEnter: storeSet,
        meta: {
            name: "Report",
            title: "레포트 관리",
            side: 'report',
            sideName: '레포트 관리',
            sideMenu: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER','ROLE_NORMAL'],
        },
    },
    {
        path: '/report/:lrIdx',
        component: () => import("../views/report/ReportDetail.vue"),
        name: "ReportDetail",
        beforeEnter: storeSet,
        meta: {
            name: "ReportDetail",
            title: "레포트 상세",
            side: 'report',
            sideName: '레포트 상세',
            sideMenu: false,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER','ROLE_NORMAL'],
        },
    },
    {
        path: '/report/:lrIdx/update',
        component: () => import("../views/report/ReportUpdate.vue"),
        name: "ReportUpdate",
        beforeEnter: storeSet,
        meta: {
            name: "ReportUpdate",
            title: "레포트 수정",
            side: 'report',
            sideName: '레포트 수정',
            sideMenu: false,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER','ROLE_NORMAL'],
        },
    },
    {
        path: '/report/:cuIdx/create',
        component: () => import("../views/report/ReportCreate.vue"),
        name: "ReportCreate",
        beforeEnter: storeSet,
        meta: {
            name: "ReportCreate",
            title: "레포트 생성",
            side: 'report',
            sideName: '레포트 등록',
            sideMenu: false,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER','ROLE_NORMAL'],
        },
    },
    // ===== 레포트 관리 =====

    // ===== 뉴스클리핑 관리 =====
    {
        path: '/news',
        component: () => import("../views/news/News.vue"),
        name: "News",
        beforeEnter: storeSet,
        meta: {
            name: "News",
            title: "뉴스클리핑 관리",
            side: 'news',
            sideName: '뉴스클리핑 관리',
            sideMenu: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER','ROLE_NORMAL'],
        },
        children: [
                    {
                        path: 'together',
                        component: () => import("../views/news/NewsTogether.vue"),
                        name: "NewsTogether",
                        beforeEnter: storeSet,
                        meta: {
                            name: "NewsTogether",
                            title: '뉴스클리핑 관리',
                            side: 'news',
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true,},
                            role: ['ROLE_SUPER','ROLE_NORMAL'],
                        },
                    },
                ],
    },
      {
        path: '/news/:ncmIdx',
        component: () => import("../views/news/NewsEdit.vue"),
        name: "NewsEdit",
        beforeEnter: storeSet,
        meta: {
            name: "NewsEdit",
            title: "뉴스클리핑 상세",
            side: 'news',
            sideName: '뉴스클리핑 상세',
            sideMenu: false,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER','ROLE_NORMAL'],
        },
    },
    // ===== 뉴스클리핑 관리 =====

        // ===== HTML 실패 관리 =====
    {
        path: '/html',
        component: () => import("../views/fail/HtmlFail.vue"),
        name: "HtmlFail",
        beforeEnter: storeSet,
        meta: {
            name: "HtmlFail",
            title: "HTML Fail",
            side: 'fail',
            sideName: 'HTML Fail',
            sideMenu: true,
            authRequired: true, storeRequired: true, storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER','ROLE_NORMAL'],
        },
    },
    // ===== HTML 실패 관리 =====





        // ===== 태그 관리 =====
    {
        path: '/parsing',
        component: () => import("../views/crawling/CrawlingParsing.vue"),
        name: "UserpCrawlingParsing",
        beforeEnter: storeSet,
        meta: {
            name: "CrawlingParsing",
            title: "태그 관리",
            side: 'tag',
            sideName: '태그 관리',
            sideMenu: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER'],
        },
    },
    // ===== 태그 관리 =====
        // ===== LLM 모델 관리 =====
    {
        path: '/llm-model',
        component: () => import("../views/llm/LlmModelList.vue"),
        name: "LlmModelList",
        beforeEnter: storeSet,
        meta: {
            name: "LlmModelList",
            title: "LLM 모델 관리",
            side: 'llmModel',
            sideName: 'LLM 모델 관리',
            sideMenu: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER'],
        },
    },
    {
        path: '/llm-model/:llmId',
        component: () => import("../views/llm/LlmModelDetail.vue"),
        name: "LlmModelDetail",
        beforeEnter: storeSet,
        meta: {
            name: "LlmModelDetail",
            title: "LLM 모델 상세",
            side: 'llmModel',
            sideName: 'LLM 모델 관리',
            sideMenu: false,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER'],
        },
    },
    // ===== LLM 모델 관리 =====
    // ===== 프롬프트 관리 =====
    {
        path: '/prompt',
        component: () => import("../views/prompt/Prompt.vue"),
        name: "Prompt",
        beforeEnter: storeSet,
        meta: {
            name: "Prompt",
            title: "프롬프트 관리",
            side: 'prompt',
            sideName: '프롬프트 관리',
            sideMenu: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER'],
        },
    },
    // ===== 프롬프트 관리 =====

    // ===== 클라우드 불용어 =====
    {
        path: '/cloudstopword',
        component: () => import("@/views/cloudstopword/ClientCloudStopword.vue"),
        name: "StopClientCloudKeyword",
        beforeEnter: storeSet,
        meta: {
            name: "StopClientCloudKeyword",
            title: '워드클라우드 관리자 불용어 관리',
            sideName: '워드클라우드 관리자 불용어 관리',
            side: 'stopClient',
            sideMenu: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER'],
        }
    },
    // ===== 클라우드 불용어 =====

    // ===== 공지사항 =====
    {
        path: '/notice',
        component: () => import("../views/notice/Notice.vue"),
        name: 'Notice',
        beforeEnter: storeSet,
        meta: {
            name: "Notice",
            title: '공지사항',
            sideName: '공지사항',
            side: 'notice',
            sideMenu: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER', 'ROLE_NORMAL'],
        }
    },
    {
        path: '/notice/create',
        component: () => import('../views/notice/NoticeCreate.vue'),
        name: 'NoticeCreate',
        beforeEnter: storeSet,
        meta: {
            name: 'NoticeCreate',
            title: '공지 등록',
            side: 'notice',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER']
        }
    },
    {
        path: '/notice/update/:idx',
        component: () => import("../views/notice/NoticeUpdate.vue"),
        name: "NoticeUpdate",
        meta: {name: 'NoticeUpdate', 
            title: '공지사항 수정', 
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            side: 'notice', 
            role: ['ROLE_SUPER']}
    },
    {
        path: '/notice/:idx',
        component: () => import("../views/notice/NoticeDetail.vue"),
        name: "NoticeDetail",
        beforeEnter: storeSet,
        meta: {
            name: 'NoticeDetail',
            title: '공지 상세',
            side: 'notice',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true,},
            role: ['ROLE_SUPER', 'ROLE_NORMAL']
        }
    },
    // ===== 공지사항 =====

    // ===== 일반 관리자 마이페이지 =====
    { //마이페이지
        path: '/myinfo',
        component: () => import("../views/my/Myinfo.vue"),
        name: "myinfo",
        beforeEnter: storeSet,
        meta: {
            name: "Myinfo", title: "내 정보", side: 'my',
            sideName: '내 정보',
            sideMenu: true,
            authRequired: true, storeRequired: true, storeConfig: {userInfo: true,}, role: ['ROLE_NORMAL'],
        },
    },
    // ===== 일반 관리자 마이페이지 =====

    // ===== 슈퍼 관리자 마이페이지 =====
    {
        path: '/myinfo/super',
        component: () => import("../views/my/MyinfoSuper.vue"),
        name: "MyinfoSuper",
        beforeEnter: storeSet,
        meta: {
            name: "MyinfoSuper", title: "내 정보", side: 'my',
            sideName: '내 정보',
            sideMenu: true,
            authRequired: true, storeRequired: true, storeConfig: {userInfo: true,}, role: ['ROLE_SUPER'],
        },
    },
    // ===== 슈퍼 관리자 마이페이지 =====
]
